import { Entry, isEntry } from '@/lib/parsers/entries';
import { BoxProps } from '../ui/Box';

import PageHeaderArticle from './PageHeader.Article';
import PageHeaderArticleIndex from './PageHeader.ArticleIndex';
import PageHeaderHome from './PageHeader.Home';
import PageHeaderOverview from './PageHeader.Overview';
import PageHeaderStandard from './PageHeader.Standard';
import PageHeaderContact from './PageHeader.Contact';
import PageHeaderCareers from './PageHeader.Careers';
import PageHeaderCommunity from './PageHeader.Community';
import PageHeaderSearch from './PageHeader.Search';

export type PageHeaderProps = BoxProps<'div'> & {
  entry: Entry;
};

const PageHeader = ({ entry }: PageHeaderProps) => {
  if (isEntry(entry, 'page', 'overview')) return <PageHeaderOverview />;
  if (isEntry(entry, 'page', 'default')) return <PageHeaderStandard />;

  if (isEntry(entry, 'careers')) return <PageHeaderCareers />;
  if (isEntry(entry, 'contact')) return <PageHeaderContact />;
  if (isEntry(entry, 'home')) return <PageHeaderHome />;
  if (isEntry(entry, 'search')) return <PageHeaderSearch />;

  if (isEntry(entry, 'communityIndex')) return <PageHeaderCommunity />;
  if (isEntry(entry, 'articleIndex')) return <PageHeaderArticleIndex />;

  if (isEntry(entry, 'article')) return <PageHeaderArticle />;

  return <PageHeaderStandard />;
};

export default PageHeader;
